import {submitFormData, submitJsonData, submitMultipartFormData} from "../../redare/utils/Request";

/**
 * Created by RdevPlugins.JsPresenterBuilderAction on 2021-11-23 10:13:03.
 */

/**
 * @param body: {platform, parentCode, parentId, status}
 * @param query: {}
 * @returns Promise
 */
export function findDictionaryList(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/base/dictionary/list',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {platform, parentCode, parentId, status}
 * @param query: {}
 * @returns Promise
 */
export function findTreeDictionaryList(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/base/dictionary/tree/list',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {dicName, dicCode, dicValue, des, extArg, platform, parentId, parentCode, sort, dicName, dicCode, dicValue, des, extArg, platform, parentId, parentCode, sort}
 * @param query: {}
 * @returns Promise
 */
export function addDictionary(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/base/dictionary/add',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {id, dicCode, dicName, dicValue, des, extArg, platform, sort}
 * @param query: {}
 * @returns Promise
 */
export function editDictionary(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/base/dictionary/edit',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {id, platform}
 * @param query: {}
 * @returns Promise
 */
export function deleteDictionary(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/base/dictionary/del',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {id, platform, dicCode, parentId}
 * @param query: {}
 * @returns Promise
 */
export function getDictionary(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/base/dictionary/info',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {id, status, platform}
 * @param query: {}
 * @returns Promise
 */
export function changeDictionaryStatus(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/base/dictionary/change',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {dragId, hoverId}
 * @param query: {}
 * @returns Promise
 */
export function sortDictionaryStatus(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/base/dictionary/sort',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

